/**
 * Created by liwenjun on 2017/9/7.
 */


/*

效果为 aaa***@gmail.com

规则：
取邮箱前缀的前三位，实际取到几位是几位，同时补充三位掩码(*)

 */

angular.module('DSSXAPP').filter('emailFormat', function () {
    /**
     * 部分隐藏邮箱
     * @param em -source email
     */
    function encodeEmail(em) {
        if (!em) {
            return em;
        }
        var atIdx, loginName, output;

        atIdx = em.indexOf("@");
        if (atIdx <= 0) {
            return em;
        }

        loginName = em.substring(0, atIdx);
        output = loginName.substr(0, 3) + '***' + em.substr(atIdx)
        return output;
    }

    return function (email) {
        return encodeEmail(email);
    };
});